import { Divider, Stack, Typography, Box } from '@mui/material'
import isEmpty from 'lodash/isEmpty'
import { useTranslation } from 'react-i18next'
import { generateSupplierRoute } from '@omnea-app/fe-suppliers/details/generateSupplierRoute'
import { EmptyMentionList } from './components/EmptyMentionList'
import { MentionSkeletonList } from './components/MentionSkeletonList'
import { ResolveAllButton } from './components/ResolveAllButton'
import { ResolveButtons } from './components/ResolveButtons'
import { ViewOlderMentions } from './components/ViewOlderMentions'
import { getFormCommentLink, getMentionTitle } from './helpers'
import { MentionBox } from './MentionBox'
import { MentionListViewProps } from './types'

export const MentionListDesktopView = ({
  loading,
  unresolvedMentionsCount,
  setShowResolved,
  showResolved,
  markAllMentionsResolved,
  displayedMentions,
  loadMore,
  hasMore,
}: MentionListViewProps) => {
  const { t } = useTranslation('dashboard')
  return (
    <Stack
      height="100%"
      sx={{
        width: '320px',
      }}
    >
      <Stack px={4} py={3} alignItems="flex-start">
        <Typography variant="H6Semibold" sx={{ py: 4 }}>
          {t('mentions.title')}
        </Typography>

        <ResolveButtons
          loading={loading}
          unresolvedMentionsCount={unresolvedMentionsCount}
          handleResolveChange={setShowResolved}
          showResolved={showResolved}
        />
      </Stack>
      <Divider />
      <Stack gap={2} px={4} py={3}>
        {!showResolved && unresolvedMentionsCount !== 0 && (
          <Box sx={{ alignSelf: 'flex-start' }}>
            <ResolveAllButton markAllMentionsResolved={markAllMentionsResolved} />
          </Box>
        )}

        {loading && <MentionSkeletonList />}

        {!loading &&
          displayedMentions &&
          displayedMentions.map(
            (mention) =>
              mention.comment && (
                <MentionBox
                  key={mention.id}
                  id={mention.id}
                  comment={mention.comment}
                  createdAt={mention.createdAt || ''}
                  name={getMentionTitle(mention)}
                  targetUrl={getFormCommentLink(mention, generateSupplierRoute)}
                  isResolved={mention.isResolved}
                  requestId={mention.requestId}
                />
              )
          )}
        {!loading && hasMore && !isEmpty(displayedMentions) && <ViewOlderMentions onClick={loadMore} />}

        {!loading && displayedMentions && isEmpty(displayedMentions) && <EmptyMentionList showResolved={showResolved} />}
      </Stack>
    </Stack>
  )
}
